<template>
  <div class="button" @click="getDistance">
    <a-icon type="pushpin" style="font-size: 18px" />
    <div>{{ isGettingDistance ? "结束拾取" : "获取距离" }}</div>
  </div>
</template>

<script>
import { mapMutations, mapState } from "vuex";
export default {
  computed: {
    ...mapState("mapTools", ["isGettingDistance", "selectedLnglat"]),
  },
  methods: {
    ...mapMutations("mapTools", ["setIsGettingDistance", "setSelectedLnglat"]),

    getDistance() {
      if (!this.isGettingDistance) {
        this.$message.info("请点击地图");
        this.setSelectedLnglat([]); // reset data
        this.setIsGettingDistance(true);
      } else {
        if (this.selectedLnglat.length > 1) {
          if (window.AMap) {
            // 返回两点间的地面距离，单位：米
            const distance = window.AMap.GeometryUtil.distanceOfLine([
              ...this.selectedLnglat.map((item) => [item.lng, item.lat]),
            ]);
            alert(
              `${this.selectedLnglat.length}个点的距离之和为${Math.round(
                distance
              ).toLocaleString()}米（${Math.round(
                distance / 1000
              ).toLocaleString()}千米）`
            );
            this.setSelectedLnglat([]); // reset data
            this.setIsGettingDistance(false);
          }
        } else {
          this.$message.error("测量面积需至少两个点");
        }
      }
    },
  },
};
</script>

<style lang="less" scoped>
.button {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
  color: #999;
  font-size: 12px;
}
</style>